// Inicializar Swipers
document.addEventListener('DOMContentLoaded', function() {
    // Áreas de Atuação (carrossel de cards na home)
    var areasEl = document.querySelector('.areas-swiper');
    if (areasEl && typeof Swiper !== 'undefined') {
        new Swiper('.areas-swiper', {
            slidesPerView: 1,
            spaceBetween: 16,
            grabCursor: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.areas-swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.areas-swiper-next',
                prevEl: '.areas-swiper-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2.3,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
            },
        });
    }

    // Depoimentos (carrossel de cards)
    var testimonialsEl = document.querySelector('.testimonials-swiper');
    if (testimonialsEl && typeof Swiper !== 'undefined') {
        new Swiper('.testimonials-swiper', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            grabCursor: true,
            pagination: {
                el: '.testimonials-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.testimonials-swiper-next',
                prevEl: '.testimonials-swiper-prev',
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });
    }
});

